import React from 'react';
import Slider from 'react-rangeslider'
import cssClasses from './MainPanner.css'

const mainPanner = (props) => {
    return (
        <div className={cssClasses.MainPanner}>
                <div className={cssClasses.Info}>
                    <p>Song A</p>
                    <p style={{color:"var(--green)",fontWeight:"bold"}}>Cross-Fade</p>
                    <p>Song B</p>
                </div>
                <Slider
                    min={-100}
                    max={100}
                    step={1}
                    value={parseFloat(props.value)}
                    onChange={props.valueChange}
                />
        </div>
    );

}

export default mainPanner;